module.exports = __webpack_public_path__ + "static/media/Investor.ddbbe76c.png";